<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import MultiselectDropdown from '../../../../../shared/components/ui/MultiselectDropdown.vue';

const props = defineProps({
  columns: {
    type: Array,
    default: () => [],
  },
  selectedColumnId: {
    type: [Number, String],
    default: null,
  },
  boardId: {
    type: [Number, String],
    default: null,
  },
  updateHistory: {
    type: Boolean,
    default: false,
  },
  ticketId: {
    type: [Number, String],
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:selectedColumnId', 'change']);

const store = useStore();

const selectedColumn = computed(() => {
  return (
    props.columns.find(column => column.id === props.selectedColumnId) || {}
  );
});

const handleColumnChange = async newColumn => {
  if (props.disabled) return;
  if (!newColumn || newColumn.id === props.selectedColumnId) return;

  emit('update:selectedColumnId', newColumn.id);
  emit('change', newColumn);

  // If updateHistory is true, update the ticket history
  if (props.updateHistory && props.ticketId && props.boardId) {
    try {
      const response = await store.dispatch('tickets/changeBoard', {
        id: props.ticketId,
        boardId: props.boardId,
        boardColumnId: newColumn.id,
      });

      if (response && response.ticket) {
        store.commit('tickets/UPDATE_TICKET', response.ticket);
      }

      // Reload ticket to ensure status label is updated after automatic status change
      await store.dispatch('tickets/getTicket', props.ticketId);
      // Refresh the ticket history immediately after the change
      await store.dispatch('tickets/getTicketHistory', props.ticketId);
    } catch (error) {
      console.error('Error updating board column:', error);
      // Revert the change on error
      emit('update:selectedColumnId', props.selectedColumnId);
    }
  }
};
</script>

<template>
  <div>
    <MultiselectDropdown
      :options="columns"
      :selected-item="selectedColumn"
      multiselector-title="Selecionar Coluna"
      multiselector-placeholder="Selecionar Coluna"
      input-placeholder="Buscar coluna..."
      no-search-result="Nenhuma coluna encontrada"
      :has-thumbnail="false"
      :disabled="!boardId || disabled"
      @select="handleColumnChange"
    />
  </div>
</template>
